export const getInitialFbCouponValues = date => ({
  type: 'FACEBOOK_COUPON',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Send Facebook DM'
        },
        {
          type: 'Google Sheet Append',
          action: 'GOOGLE_SHEET_APPEND',
          sheetUrl: '',
          row: ''
        }
      ],
      triggers: [
        {
          type: 'Comments On Post'
        },
        {
          type: 'Match Hashtag',
          value: []
        }
      ],
      platform: 'facebook',
      description: 'Opt-In',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: false,
  enableBlastFiltering: false,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-coupon/create/container/initialValues.js